import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import useAuth from '../../features/auth/useAuth';

import Button from '../Assets/Button';
import LogoButton from '../Assets/LogoButton';

import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../App/redux/store';
import { modalsActions } from '../../features/modals/modalsSlice';
import { ReactComponent as MapMarker } from '../../images/map-marker.svg';
import { marketStudiesActions } from '../../store/marketStudies/actions';
import { dateFormat } from '../../utils/jsFunctions';

function MarketStudiesCard({ content }) {
  const { city, createdAt, owner, propertyTypology, id, name } = content;
  const { userIdIri } = useAuth({});
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleConsult = () => {
    dispatch(marketStudiesActions.resetActiveMarketStudy.success());
    navigate(`/etude-de-marche-resultats/${id}`);
  };
  const getPropertyTypologiesStrings = () => {
    return propertyTypology ? propertyTypology.name : '';
  };

  const isOwner = owner ? owner.idIri === userIdIri : false;

  return (
    <div className="market-studies-card">
      <header className="market-studies-card-header">
        <h4 className="market-studies-card-title">{name}</h4>
        {owner && (
          <span className="market-studies-card-subtitle">{`Créé par ${owner.fullName}`}</span>
        )}
      </header>

      <section className="market-studies-card-content">
        <div className="market-studies-card-city">
          <MapMarker />
          <span>{city.name}</span>
        </div>
        <span className="market-studies-card-types">
          {getPropertyTypologiesStrings()}
        </span>
      </section>

      <footer className="market-studies-card-footer">
        <div className="market-studies-card-elt">
          <span className="market-studies-card-date">{dateFormat(createdAt)}</span>
        </div>
        <div className="market-studies-card-footer-btns">
          <Button
            btnType="button"
            btnContent="Consulter"
            handleClick={handleConsult}
            primary
            disabled={isEmpty(city) || isEmpty(propertyTypology) ? true : false}
          />
          {isOwner && (
            <>
              <LogoButton
                btnType="button"
                handleClick={() => navigate(`/etudes-de-marche-modification/${id}`)}
                btnLogo="pen-violet"
                tooltip={`Modifier`}
              />
              <LogoButton
                btnType="button"
                handleClick={() =>
                  dispatch(
                    modalsActions.deleteMarketStudy({
                      idIri: content.idIri,
                      name: content.name,
                    }),
                  )
                }
                btnLogo="delete-red"
                tooltip={`Supprimer`}
              />
            </>
          )}
        </div>
      </footer>
    </div>
  );
}

MarketStudiesCard.propTypes = {
  content: PropTypes.object.isRequired,
};

export default MarketStudiesCard;
